import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { dropdownValues } from '@app/shared/interfaces/common.model';
import { RTOdrill } from '@app/shared/interfaces/rto-drill';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { EmeraldModalModule } from '@emerald-angular/modal';

@Component({
  selector: 'app-vendor-rto-drill-filter',
  standalone: true,
  imports: [
    EmeraldDropdownModule,
    ReactiveFormsModule,
    EmeraldButtonModule,
    EmeraldModalModule,
    CommonModule,
  ],
  templateUrl: './vendor-rto-drill-filter.component.html',
  styleUrl: './vendor-rto-drill-filter.component.scss',
})
export class VendorRTODrillFilterComponent {
  @Input() contractorData: RTOdrill[] = [];
  @Output() onResetFilter = new EventEmitter<any>();
  @Output() onApplyFilter = new EventEmitter<any>();

  opened: boolean = false;
  filterForm: FormGroup = new FormGroup({});
  openForm: boolean = true;
  reportingManagerOptions: dropdownValues[] = [];
  lobOptions: dropdownValues[] = [];
  locationOptions: dropdownValues[] = [];
  constructor() {}

  initializeForm() {
    this.filterForm = new FormGroup({
      reportingManager: new FormControl(''),
      lob: new FormControl(''),
      location: new FormControl(''),
    });
  }

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(): void {
    if (this.contractorData?.length) {
      this.loadFilterData();
    }
  }

  private loadFilterData(): void {
    if (!this.contractorData?.length) return;
    this.reportingManagerOptions = this.getDropdownOptions('reportingManager');
    this.lobOptions = this.getDropdownOptions('lob');
    this.locationOptions = this.getDropdownOptions('location');
  }

  private getDropdownOptions(property: keyof RTOdrill): dropdownValues[] {
    const seen = new Set<string>();
    let filtered = this.contractorData;
    let filteredValue = filtered
      .map((item) => item[property])
      .filter(
        (value) =>
          this.isValidValue(value) &&
          !seen.has(value as string) &&
          seen.add(value as string),
      )
      .map((value, index) => ({
        label: value as string,
        value: value as string,
        id: index + 1,
      }));
    return filteredValue;
  }

  private isValidValue(value: any): boolean {
    return typeof value === 'string' && value.trim() !== '';
  }

  apply(): void {
    if (this.filterForm.valid) {
      const { reportingManager, lob, location } = this.filterForm.value;
      const filtered = this.contractorData;
      const filteredData = filtered.filter((item) => {
        const matchesReportingManager = reportingManager
          ? item.reportingManager === reportingManager.value
          : true;
        const matchesLob = lob ? item.lob === lob.value : true;
        const matchesLocation = location
          ? item.location === location.value
          : true;
        return matchesReportingManager && matchesLob && matchesLocation;
      });
      this.onApplyFilter.emit(filteredData);
      this.opened = false;
    }
  }
  reset() {
    this.filterForm.reset();
    this.openForm = false;
      setTimeout(() => {
        this.openForm = true;
      });
    this.onResetFilter.emit(this.contractorData);
  }
}
